import { defineMessages } from 'react-intl';

export default defineMessages({
  msLogo: {
    id: 'header.logo.msg',
    defaultMessage: 'Microsoft Logo',
  },
});
